import { faLink, faReply } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';
import Pagination from 'components/pagination';
import { formatDate } from 'helpers/utils';
import { PrioritySelect } from 'hooks/useTicketsTable';
import { Card, Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CardLayout = ({
  tickets,
  filters,
  setFilters,
  isSelectedItem,
  toggleSelectedItem
}) => {
  return (
    <>
      <Flex
        direction={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        className="w-100 gap-3 mb-3"
      >
        {tickets.content.slice(0, 12).map((ticket, index) => (
          <div
            key={index}
            style={{ width: '95%' }}
            className="mt-3 bg-white dark__bg-1100 d-md-flex d-xl-inline-block d-xxl-flex align-items-center p-x1 rounded-3 shadow-sm card-view-height"
          >
            <div className="d-flex align-items-start align-items-sm-center">
              <Form.Check
                type="checkbox"
                id="inboxBulkSelect"
                className="fs-0 form-check me-2 me-xxl-3 mb-0"
              >
                <Form.Check.Input
                  type="checkbox"
                  checked={isSelectedItem(ticket.id)}
                  onChange={() => toggleSelectedItem(ticket.id)}
                />
              </Form.Check>
              <div className="ms-1 ms-sm-3">
                <p className="fw-semi-bold mb-3 mb-sm-2">
                  {ticket.parentTicket && (
                    <OverlayTrigger
                      overlay={
                        <Tooltip>
                          Ticket pai: #{ticket.parentTicket.code}
                        </Tooltip>
                      }
                    >
                      <span className="me-2">
                        <FontAwesomeIcon icon={faLink} size="sm" />
                      </span>
                    </OverlayTrigger>
                  )}
                  <Link to={`/tickets/${ticket.id}`}>
                    #{ticket.code} {ticket.subject}
                  </Link>
                  {ticket.answered && (
                    <OverlayTrigger
                      overlay={<Tooltip>Respondido pelo solicitante</Tooltip>}
                    >
                      <span className="ms-2">
                        <FontAwesomeIcon icon={faReply} size="sm" />
                      </span>
                    </OverlayTrigger>
                  )}
                </p>
                <Row className="align-items-center gx-0 gy-2">
                  <Col xs="auto" className="me-2">
                    <h6 className="mb-0">
                      <Link
                        to={`/registration/customers/${ticket.customer.id}`}
                        className="text-800 d-flex align-items-center gap-1"
                      >
                        <FontAwesomeIcon
                          icon="user"
                          transform="shrink-3 up-1"
                        />
                        <span>
                          {ticket.customer.fantasyName || ticket.customer.name}
                        </span>
                      </Link>
                    </h6>
                  </Col>
                  <Col xs="auto" className="lh-1 me-3">
                    <SoftBadge style={{ backgroundColor: ticket.status.color }}>
                      {ticket.status.description}
                    </SoftBadge>
                  </Col>
                  <Col xs="auto">
                    <h6 className="mb-0 text-500">
                      {formatDate(ticket.creationDate)}
                    </h6>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="border-bottom mt-4 mb-x1"></div>
            <div className="d-flex justify-content-between ms-auto">
              <PrioritySelect
                title={ticket.priority.description}
                color={ticket.priority.color}
                data={ticket.priority.data}
                className="ms-md-4 ms-xl-0"
                style={{ width: '7.5rem' }}
              />
              <h6>{ticket.agent ? ticket.agent.firstName : '---'}</h6>
            </div>
          </div>
        ))}
      </Flex>

      <Card.Footer>
        <Pagination data={tickets} filters={filters} setFilters={setFilters} />
      </Card.Footer>
    </>
  );
};

export default CardLayout;
